import { ISeoMetaData } from '.'

export const accountHomeSeoMetaData: ISeoMetaData[] = [
  {
    path: '/home',
    component: 'Account Home',
    seo: {
      en: {
        title: `Welcome! | Medicare`,
        description: ''
      },
      es: {
        title: ``,
        description: ''
      }
    }
  },
  {
    path: '/home/alloptions',
    component: 'Account Home Modal',
    seo: {
      en: {
        title: 'What do you want to do? | Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  }
]
